export { default as EmployeesPage } from './EmployeesPage';
export { default as MachineryPage } from './MachineryPage';
export { default as SuppliersPage } from './SuppliersPage';
export { default as TrucksPage } from './TrucksPage';
export { default as MaterialsPage } from './MaterialsPage';
export { default as CatalogManager } from './CatalogManager';
